var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"draggable-container",class:{grabbing: _vm.grabbing},on:{"mousedown":_vm.mouseDown,"mouseup":_vm.mouseUp,"mousemove":_vm.mouseMove,"mouseleave":_vm.mouseLeave}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }